import { Preview } from 'containers/CahierJournal/Preview';
import {
  useCjPreviewShareSettings,
  useSetCjPreviewShareSettings,
} from 'containers/CahierJournal/CJShare/atom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';
import { CahierJournalView } from 'containers/CahierJournal/types';
import getDateFromCJUrl from 'utils/time/getDateFromCJUrl';
import { useParams } from 'react-router-dom';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

export function PreviewCJShare() {
  const user = useUser();
  const classrooms = useClassrooms();
  const cjPDFSettings = useCjPreviewShareSettings();
  const { schoolyear, school } = useSchoolSchoolyear();
  const onUpdate = useSetCjPreviewShareSettings();
  const params = useParams<{
    view: CahierJournalView;
    year: string;
    month: string;
    day: string;
  }>();
  const year = params.year as string;
  const month = params.month as string;
  const day = params.day as string;
  const view = params.view as CahierJournalView;
  const date = getDateFromCJUrl(year, month, day);

  return (
    <Preview
      initialValue={cjPDFSettings}
      onUpdate={onUpdate}
      lng={user.locale}
      tz={user.location}
      classrooms={classrooms}
      view={view}
      date={date}
      schoolyearId={schoolyear.id}
      schoolId={school.id}
      limitedBgSet
    />
  );
}
